export default __webpack_public_path__ + "static/media/019-sand castle.ead55fcf.svg";